import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-end mb-4"
}
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "d-flex flex-row" }

import { ref, computed, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import router from '@/router'
import swal from '@/_helpers/swal'

import DataTable from 'primevue/datatable'
import Button from 'primevue/button'
import Column from 'primevue/column'
import InputSwitch from 'primevue/inputswitch'

import { changeStateMiddleMenu, fetchAll, fetchAllActive } from '@/_services/homepage/middleMenu'
import { IMiddleMenu } from '@/models/homepage/IMiddleMenu'


export default /*#__PURE__*/_defineComponent({
  __name: 'MiddleMenuList',
  setup(__props) {

const tableData = ref<IMiddleMenu[]>([])
const rows = ref(10)
const currentPage = ref(0)
const isLoading = ref(true)
const totalRecords = ref(0)
const criteria = ref('')
const page = ref(1)
const modeSortable = ref(false)

const defaultSort = {
    fieldLabel: 'order[createdAt]',
    fieldValue: 'desc'
}

const route = useRoute()

const type = computed(() => route.meta?.type as string | undefined)

const title = computed(() => {
    switch (type.value) {
        case 'travelBloc':
            return 'GÉRER LES VOYAGES'
        case 'regionBloc':
            return 'GÉRER LES RÉGIONS'
        default:
            return 'Gérer les listes des références'
    }
})

watchEffect(() => {
    loadData()
})

async function loadData() {
    isLoading.value = true
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchAll(
        rows.value,
        page.value,
        criteria.value,
        defaultSort,
        type.value
    )
    totalRecords.value = totalRecordsDt.value
    tableData.value = tableDataDt.value
    isLoading.value = loadingDt.value
}

const changeState = async (uuid: string, isActive: boolean) => {
    const message = isActive
        ? 'Êtes-vous sûr de vouloir activer cette référence ?'
        : 'Êtes-vous sûr de vouloir désactiver cette référence ?'

    const result = await swal.confirm(message)

    if (result.isConfirmed) {
        await changeStateMiddleMenu(uuid, isActive)
        const msg = isActive
            ? "Vous venez d'activer une référence."
            : "Vous venez de désactiver une référence."
        swal.success('Opération réussie !', msg)
        loadData()
    }
}

function onPaginate(e: any) {
    rows.value = e.rows
    currentPage.value = e.page
    page.value = currentPage.value + 1
    loadData()
}

function onSort(e: any) {
    const sort = e.sortField
        ? {
            fieldLabel: `order[${e.sortField}]`,
            fieldValue: e.sortOrder === 1 ? 'asc' : 'desc'
        }
        : defaultSort

    modeSortable.value = !!e.sortField
    loadData()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(title.value), 1)
    ]),
    (type.value !== 'travelBloc')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(Button), {
            label: type.value && type.value === 'regionBloc' ? 'Ajouter une région' : 'Ajouter une référence',
            onClick: _cache[0] || (_cache[0] = () => type.value && type.value === 'regionBloc'
              ? _unref(router).push({ name: 'addMiddleMenu', params: { type: 'region' } })
              : _unref(router).push({ name: 'addMiddleMenu' })),
            icon: "pi pi-plus",
            "aria-label": "Ajouter une référence",
            class: "button-add"
          }, null, 8, ["label"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(DataTable), {
        lazy: "",
        value: tableData.value,
        paginator: true,
        rows: rows.value,
        removableSort: "",
        loading: isLoading.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        rowsPerPageOptions: [10, 25, 100],
        currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
        onPage: onPaginate,
        onSort: onSort
      }, {
        empty: _withCtx(() => [
          _createTextVNode("Aucun produit ne correspond à votre recherche")
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            field: "title",
            header: "Titre"
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", null, _toDisplayString(data.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "position",
            header: "Position"
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", null, _toDisplayString(data.position), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "uuid",
            header: "Id"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.reference), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "action",
            header: "Action"
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(Button), {
                  size: "small",
                  icon: "pi pi-eye",
                  class: "p-button-eye",
                  style: {"margin-right":"0.5em"},
                  title: "Voir",
                  onClick: () => {
                              if (type.value === 'regionBloc') {
                                _unref(router).push({ name: 'middleMenuItemList', params: { uuid: data.uuid, type: 'region' } })
                              } else if (type.value === 'travelBloc') {
                                _unref(router).push({ name: 'middleMenuItemList', params: { uuid: data.uuid, type: 'travel' } })
                              } else {
                                _unref(router).push({ name: 'middleMenuItemList', params: { uuid: data.uuid } })
                              }
                            }
                }, null, 8, ["onClick"]),
                _createVNode(_unref(Button), {
                  size: "small",
                  icon: "pi pi-pencil",
                  class: "p-edition",
                  style: {"margin-right":"0.5em"},
                  title: "Éditer",
                  onClick: () => {
                              if (type.value === 'regionBloc') {
                                _unref(router).push({ name: 'editMiddleMenu', params: { uuid: data.uuid, type: 'region' } })
                              } else if (type.value === 'travelBloc') {
                                _unref(router).push({ name: 'editMiddleMenu', params: { uuid: data.uuid, type: 'travel' } })
                              } else {
                                _unref(router).push({ name: 'editMiddleMenu', params: { uuid: data.uuid } })
                              }
                            }
                }, null, 8, ["onClick"]),
                _createVNode(_unref(InputSwitch), {
                  modelValue: data.active,
                  "onUpdate:modelValue": ($event: any) => ((data.active) = $event),
                  "input-id": data.uuid,
                  onInput: ($event: any) => (changeState(data.uuid, data.active))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "input-id", "onInput"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "rows", "loading", "totalRecords", "currentPage"])
    ])
  ], 64))
}
}

})